<template>
  <div class="userPowerDialog">
    <el-dialog title="编辑用户"
      :visible.sync="$parent.userDialogVisible"
      width="30%">
      <el-form :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item label="姓名"
          prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="部门/岗位"
          prop="region">
          <el-cascader :options="treeAllData"
            v-model="ruleForm.region"
            :props="{
              checkStrictly: true,
              value: 'id',
              label: 'name',
              emitPath: false,
            }"
            clearable
            :disabled="!activeItem.tenantId"></el-cascader>
        </el-form-item>
        <el-form-item label="手机号码"
          prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item :label="activeItem.tenantId ? '登录密码' : '重置密码'"
          prop="password"
          :required="activeItem.tenantId ? true : false">
          <el-input v-model="ruleForm.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="$parent.userDialogVisible = false">取 消</el-button>
        <el-button type="primary"
          :loading="btnLoading"
          @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: ["activeItem", "treeAllData"],
  data() {
    let validatePass = (rule, value, callback) => {
      if (this.activeItem.tenantId || value !== "") {
        let passwordRules =
          /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,16}$/;
        if (value === "") {
          callback(new Error("请输入登录密码"));
        } else {
          if (!passwordRules.test(value)) {
            callback(
              new Error("密码长度为8-16位且包含数字/字母/特殊字符至少两种")
            );
          }
          callback();
        }
      } else {
        callback();
      }
    };
    let checkRealName = (rule, value, callback) => {
      //验证名字的正则表达式
      const realnameReg =
        /^[\u4E00-\u9FA5]{2,7}([\u25CF\u00B7][\u4E00-\u9FA5]{2,7})*$/;
      if (!value) {
        return callback(new Error("请输入姓名"));
      }
      setTimeout(() => {
        if (!realnameReg.test(value)) {
          return callback(new Error("请输入2-14个汉字"));
        } else {
          callback();
        }
      }, 100);
    };
    return {
      btnLoading: false,
      ruleForm: {
        name: "",
        region: "",
        phone: "",
        password: "",
      },
      options: [],
      rules: {
        name: [{ required: true, trigger: "change", validator: checkRealName }],
        region: [
          { required: true, message: "请选择部门/岗位", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            pattern: /^1[3|5|7|8|9]\d{9}$/,
            message: "请输入正确的号码格式",
            trigger: "change",
          },
        ],
        password: [{ validator: validatePass, trigger: "change" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true;
          let res = await api.authorityEditUser({
            id: this.activeItem.tenantId ? null : this.activeItem.id,
            departmentId: this.ruleForm.region,
            name: this.ruleForm.name,
            phone: this.ruleForm.phone,
            password: this.ruleForm.password ? this.ruleForm.password : null,
          });
          if (res && res.data.code == 200) {
            this.btnLoading = false;
            this.$message.success(
              this.activeItem.tenantId ? "添加成功" : "修改成功"
            );
            this.$parent.userDialogVisible = false;
            this.$store.commit("SET_LOADING", true);
            setTimeout(() => {
              this.$parent.getUserList();
            }, 500);
          } else {
            this.btnLoading = false;
            this.$message.error(res.data.codeMsg);
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.activeItem.tenantId) {
      this.ruleForm.region = this.activeItem.id;
      this.ruleForm.password = "a00000000";
    } else {
      this.ruleForm.region = this.activeItem.departmentId;
      this.ruleForm.name = this.activeItem.name;
      this.ruleForm.phone = this.activeItem.phone;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>